import { useState } from 'react';

export function useBootstrapValidation() {
  const [validated, setValidated] = useState(false);

  const validateForm = (formEl) => {
    if (!formEl.checkValidity()) {
      setValidated(true);
      return false;
    }
    return true;
  };

  const resetValidation = () => setValidated(false);

  return { validated, validateForm, resetValidation };
}
